import { render, staticRenderFns } from "./ModalFilesPreview.vue?vue&type=template&id=3fbb53cd&"
import script from "./ModalFilesPreview.vue?vue&type=script&lang=js&"
export * from "./ModalFilesPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports